import { createAsyncThunk } from '@reduxjs/toolkit';
import Api from '../../api';

export const getTranslation = createAsyncThunk('translation/getTranslation', async (payload, thunkAPI) => {
  try {
    const { data } = await Api.getTranslation();
    return data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e.response.data);
  }
});
